import moment from 'moment';

const state = () => ({
    toastModel: {
        show: false,
        msTimeout: 6000,
        text: '',
        posY: 'top',
        posX: null,
        time: '',
        date: ''
    }
});


const getters = {
    getToastModel: state => state.toastModel
};


const mutations = {
    POP_TOAST(state, message) {
        state.toastModel = new toast(
            true, 
            6000, 
            message.split(",")[0], 
            "top", 
            "right", 
            message.split(",")[2], 
            message.split(",")[1]
        );
    },
    HIDE_TOAST(state) {
        state.toastModel.show = false;
    }
};


const actions = {
    toast(context, data) {
        
        var message = data;
        var dateStamp = moment().format("DD/MM/YYYY");
        var timeStamp  = moment().format("HH:mm:ss");
          
        context.commit('POP_TOAST', message + "," + dateStamp.toString() + "," + timeStamp.toString());
        //dont forget to time out the notification
        setTimeout(() => {
            context.commit('HIDE_TOAST');
        }, context.state.toastModel.msTimeout)
    },
    unToast(context) {
        context.commit('HIDE_TOAST');
    }
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

function toast(show, msTimeout, text, posY, posX, time, date) {
    this.show = show;
    this.msTimeout = msTimeout;
    this.text = text;
    this.posY = posY;
    this.posX = posX;
    this.time = time;
    this.date = date;
}